export default "__VITE_ASSET__V2H90sWU__"